<template>
  <div class="wall-container">
    <div class="sel-tab-box">
      <div
        class="sel-tab"
        :style="{ background: 'url(' + require('./../assets/' + tabbt) + ') no-repeat 0 0 / 100% auto', }"
      >
        <span><span>全国{{ title }} TOP10</span></span>
      </div>
    </div>
    <div class="top-box">
      <div :class="(index===0||index===1||index===2)?'box-item-top':'box-item'" v-for="(i,index) of dataList">
        <div class="image-box">
          <img height="100%" v-if="index===0||index===1||index===2"
            :src="`https://survey.iscn.org.cn/system/mallMiniProgram/img/dataReport/top${index+1}.png`"
          />
          <span v-else>{{ index+1 }}</span>
        </div>
        <div>
          {{ (type==='发起单位'||type==='志愿服务团体(个人)')?`${i.name}`:`${i.associatedName}` }}
        </div>
        <div>
          {{ i.amount+i.specialAmount }}
        </div>
        <div>
          <el-button v-if="i.amount>50" @click="handleClick(i)" type="primary" size="mini">{{isPc?'生成喜报':'喜报'}}</el-button>
          <el-button v-else  type="info" disabled size="mini">{{isPc?'生成喜报':'喜报'}}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'wall',
  props: {
    tabbt: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    show: {
      type: Boolean,
      default: false
    },
    dataList: {
      type: Array,
      default: []
    },
    type: {
      type: String,
      default: ""
    },
    isPc: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      invitationLoading: true,
    }
  },
  created() {
    
  },
  methods: {
    handleClick(data) {
      // 调用传入的点击事件处理器
      this.$emit('onClick', data, 1);
    },
  }
};
</script>

<style scoped>
.wall-container {
  padding: 30px;
  min-height: 620px;
}
.sel-tab-box {
  width: 100%;
}
.sel-tab {
  display: inline-block;
  padding: 10px;
  color: #fff;
  font-weight: 600;
  font-size: 22px;
}
.top-box {
  background: #fff ;
  flex: 20;
  display: flex;
  flex-direction: column;
  margin: 10px auto;
}
.box-item {
  flex: 1;
  border-bottom: 1px solid #ccc;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 10px;
  margin-bottom: 5px;
  /* line-height: 36px; */
}
.box-item-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
  border: none;
  padding: 5px 10px;
}
.box-item-top>div:nth-child(1){
  width: 40px;
}
.box-item-top>div:nth-child(2){
  flex: 1;
  margin-right: 10px;
  text-align: center;
}
.box-item-top>div:nth-child(3){
  width: 66px;
  text-align: center;
}
.box-item>div:nth-child(1){
  width: 40px;
}
.box-item>div:nth-child(2){
  flex: 1;
  margin-right: 10px;
  text-align: center;
}
.box-item>div:nth-child(3){
  width: 66px;
  text-align: center;
}
.top-box>div:nth-child(1){
  background: #FFD76F;
  border-radius: 5px;
}
.top-box>div:nth-child(2) {
  background: #DCDCDC;
  border-radius: 5px;
}
.top-box>div:nth-child(3) {
  background: #FFC197;
  border-radius: 5px;
}
.image-box {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
}
.image-box img{
  max-width: 30px;
  /* max-height: 50px; */
}
@media screen and (max-width: 550px) {
  .wall-container {
    padding: 20px 10px;
  }
  .sel-tab {
    font-size: 18px;
  }
    
}
</style>


// WEBPACK FOOTER //
// src/components/wall.vue